import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { FieldsetModule } from 'primeng/fieldset';
import { InputTextarea } from 'primeng/inputtextarea';
import { TooltipModule } from 'primeng/tooltip';
import { sanitizeTextarea } from 'src/app/common/input-utils';
import { MAX_RECOMENDACIONES_CUMPLIMIENTO } from 'src/app/common/constants-ejb';
import { ContadorCaracteresDirective } from 'src/app/presentation/shared/contador-caracteres/contador-caracteres.directive';

/**
 * DUMB COMPONENT: SeccionRecomendaciones
 *
 * Panel de recomendaciones.
 * Solo visible para tipo INFORME.
 *
 * Legacy: CreateOrUpdateCumplimientoViewImpl.ui.xml líneas 450-455
 * Legacy: panelRecomendCumpl.setVisible(isTipoInforme) - línea 786
 */
@Component({
  selector: 'app-seccion-recomendaciones',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FieldsetModule,
    InputTextarea,
    TooltipModule,
    ContadorCaracteresDirective
  ],
  template: `
    <p-fieldset legend="Recomendaciones" [toggleable]="true" styleClass="mb-4">
      <div [formGroup]="form()">
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Recomendaciones
          @if (obligatorio()) {
            <span class="text-red-500">*</span>
          }
        </label>
        <textarea
          pInputTextarea
          formControlName="recomendacionesInforme"
          (input)="sanitizeRecomendaciones()"
          rows="4"
          class="w-full"
          [appContadorCaracteres]="maxRecomendaciones"
          pTooltip="Ingrese las recomendaciones"
        >
        </textarea>
      </div>
    </p-fieldset>
  `
})
export class SeccionRecomendacionesComponent {
  readonly maxRecomendaciones = MAX_RECOMENDACIONES_CUMPLIMIENTO;
  form = input.required<FormGroup>();
  obligatorio = input<boolean>(false);

  /**
   * Sanitiza el campo Recomendaciones contra XSS/SQLi (seguridad-girop §3).
   */
  sanitizeRecomendaciones(): void {
    const ctrl = this.form().get('recomendacionesInforme');
    if (ctrl) {
      ctrl.setValue(sanitizeTextarea(ctrl.value ?? ''), { emitEvent: false });
    }
  }
}
